<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[View Carrier] ' + carrier.carrier_name + ' - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/carriers">Carriers</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {{ carrier.carrier_name }}
                    </li>

                </ol>
            </nav>

            <h4 class="page-header mb-3">
                {{ carrier.carrier_name }}
            </h4>

            <div class="mb-3" v-if="canEdit">
                <router-link :to="`/carriers/edit/${carrier.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
                <router-link :to="`/carriers/delete/${carrier.id}`" class="btn btn-sm btn-default"><span class="text-danger"><i class="fas fa-trash"></i> Delete</span></router-link>
            </div>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 mb-md-0 mb-3">
                                    <div class="row mb-3">
                                        <div class="col-md-4 col-12 text-md-right">Carrier:</div>
                                        <div class="col-md-8 col-12 input-group-sm">
                                            {{ carrier.carrier_name }}
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 col-12 text-md-right">Last Updated:</div>
                                        <div class="col-md-8 col-12 input-group-sm">
                                            {{ carrier.updated_at | moment('timezone', timezone, "MM/DD/YYYY hh:mm a") }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row mb-3">
                                        <div class="col-md-4 col-12 text-md-right">Website:</div>
                                        <div class="col-md-8 col-12 input-group-sm">
                                            {{ carrier.website }}
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 col-12 text-md-right">Active:</div>
                                        <div class="col-md-8 col-12 input-group-sm">
                                            <label class="badge badge-success" v-if="carrier.is_active == 1">Active</label>
                                            <label class="badge badge-warning" v-else-if="carrier.is_active == 0">Inactive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <ul class="search-nav nav nav-tabs tabs-alt container-m--x mt-4">
                        <b-nav-item :active="curTab === 'products'" @click="curTab = 'products'">
                            Products ({{ products.length }})
                        </b-nav-item>
                        <b-nav-item :active="curTab === 'history'" @click="curTab = 'history'">
                            <i class="fas fa-clock"></i> History <span v-if="historyCount">({{ historyCount }})</span>
                        </b-nav-item>
                    </ul>

                    <div class="pt-2">
                        <div class="card" v-show="curTab === 'products'">
                            <div class="card-body">
                                <v-client-table :columns="['product_name', 'product_type_name', 'description']" :options="{headings: {product_name: 'Product', product_type_name: 'Product Type'}}" :data="products">
                                    <div slot="afterFilter" class="ml-2">
                                        <router-link :to="`/products/create?carrier_id=${carrier.id}`" class="btn btn-xs btn-success"><span class="text-"><i class="fa fa-plus-circle"></i> Add New Product</span></router-link>
                                    </div>

                                    <template slot="product_name" slot-scope="props">
                                        <router-link :to="`/products/view/${props.row.id}`" title="View Agent">{{ props.row.product_name }}</router-link>
                                    </template>

                                </v-client-table>
                            </div>
                        </div>

                        <div class="card" v-show="curTab === 'history'">
                            <div class="card-body">
                                <history-list :record_id="carrier.id" record_type="Carrier" @historyCount="(count) => { this.historyCount = count; }" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Emails ({{ carrier.emails.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <email-list :emails="carrier.emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header"><strong>Phones ({{ carrier.phones.length }})</strong></div>
                        <div class="card-body">
                            <phone-list :phones="carrier.phones" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header"><strong>Addresses ({{ carrier.addresses.length }})</strong></div>
                        <div class="card-body">
                            <address-list :addresses="carrier.addresses" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Contacts:</strong>

                            <div class="float-right" v-if="canEdit">
                                <router-link :to="`/contacts/create?record_type=Carrier&record_id=${carrier.id}`" class="btn btn-sm btn-default"><i class="fa fa-plus-circle"></i> Add</router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <contact-list :contacts="contacts" permission="carriers.manage" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                curTab: 'products',
                id: this.$route.params.id,
                timezone: this.$root.timezone,
                carrier: {},
                products: [],
                contacts: [],
                files: [],
                historyCount: null,
            }
        },

        computed: {
            canEdit(){
                return this.$root.hasPermission('carriers.manage');
            }
        },

        methods: {

            getCarrier(){
                //Send it
                this.$http.get('/carriers/view/' + this.id)
                    .then(response => {
                        //Set the carrier
                        this.carrier = response.data.carrier;
                        this.products = response.data.products;
                        this.contacts = response.data.contacts;
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted() {
            //get the carrier?
            this.getCarrier();
        }
    }
</script>
